export default __webpack_public_path__ + "static/media/img-3296.fbdd66f0.jpeg";